import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { JwlTable, Chip, LoadingSpinner, ErrorComponent } from '../../../../components';
import { userLanguage } from '../../../../core/AuthContext';

import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';
import { PlatformNavigation } from '../../navigation/PlatformNavigation';

const PlatformSaleCatalogList: React.FC = () => {
  const history = useHistory();
  const [errorComponentState, setErrorComponentState] = useState(false);
  const [filteredPlatformSaleCatalogs, setFilteredPlatformSaleCatalogs] = useState('');

  const {
    data: saleCatalogsData,
    loading: saleCatalogsLoading,
    error: saleCatalogsError,
    refetch: refetchSaleCatalogs
  } = GQLOperationBuilder.platformSaleCatalog.getPlatformSaleCatalogs(
    { includeOnlyActiveContracts: true },
    { fetchPolicy: 'network-only' }
  );

  const {
    data: merchantContractsData,
    loading: merchantContractsLoading,
    error: merchantContractsError,
    refetch: merchantContractsRefetch
  } = GQLOperationBuilder.platformSaleCatalog.getPlatformSaleCatalogWithPlatformMerchantContracts({
    includeOnlyActiveContracts: true
  });

  if (saleCatalogsLoading || merchantContractsLoading) return <LoadingSpinner />;
  const handleFilterChange = (event: any) => setFilteredPlatformSaleCatalogs(event.target.value);

  if (saleCatalogsError && !errorComponentState)
    return (
      <ErrorComponent
        close={setErrorComponentState}
        details={saleCatalogsError?.stack}
        callback={refetchSaleCatalogs}
        message={saleCatalogsError.message}
      />
    );

  const merchantContracts = GQLOperationBuilder.platformSaleCatalog.platformSaleCatalogWithPlatformMerchantContractArrayFromResponse(
    merchantContractsData
  );

  const getPlatformSaleCatalogsRows = () => {
    return GQLOperationBuilder.platformSaleCatalog
      .platformSaleCatalogArrayFromResponse(saleCatalogsData)
      .filter(catalog => {
        return `${catalog.name.en}${catalog.description.en}${catalog.id}`
          .toLowerCase()
          .includes(filteredPlatformSaleCatalogs.toLowerCase().trim());
      })
      .map(saleCatalog => {
        const associatedMerchantContracts = merchantContracts.filter(
          m => m.platformSaleCatalog.id === saleCatalog.id
        );
        return {
          id: saleCatalog.id,
          cells: [
            saleCatalog.name[userLanguage],
            <Chip
              size="small"
              mr={1}
              mb={1}
              label={associatedMerchantContracts.length}
              $active={associatedMerchantContracts.length > 0}
            />,
            <Chip
              size="small"
              mr={1}
              mb={1}
              label={saleCatalog.isPublished ? 'YES' : 'NO'}
              $active={!!saleCatalog.isPublished}
            />,
            saleCatalog.deliveryUnitSaleCatalog.name[userLanguage],
            saleCatalog.deliveryUnitSaleCatalog.inventoryCatalog.pieceInventorys.length,
            saleCatalog.deliveryUnitSaleCatalog.inventoryCatalog.accessoryInventorys.length,
            saleCatalog.deliveryUnitSaleCatalog.pricingCatalogs.map(c => c.currency).join(','),
            new Date(Date.parse(saleCatalog.updatedAt)).toLocaleString()
          ]
        };
      });
  };

  const navigateToPlatformSaleCatalogDetails = (platformSaleCatalogId: string) => {
    history.push(
      PlatformNavigation.platformSaleCatalogDetails.pathFromParams({
        platformSaleCatalogId: platformSaleCatalogId
      })
    );
  };

  return (
    <JwlTable
      title="Platform Sale Catalogs List"
      description="The platform sale catalog contains a complete information in regards with the commercial offer of the platform at a specific moment & in regards with a specific producer / delivery unit."
      columns={[
        'Platform Sale Catalog Name ',
        'Active Merchant contracts',
        'Published',
        'Delivery Unit Sale Catalog Name',
        'Pieces',
        'Accessories',
        'Currency',
        'Updated At'
      ]}
      rows={getPlatformSaleCatalogsRows()}
      onFilterChange={handleFilterChange}
      onTableRowClick={navigateToPlatformSaleCatalogDetails}
    />
  );
};

export default PlatformSaleCatalogList;
